import React from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';
export default function Footer(): JSX.Element {
	return (
		<footer className="layout-footer px-4">
			<div className="container-xxl py-1">
				<Row>
					<Col md={6} className="pt-2">
						<a href="#top" rel="noopener noreferrer" title="On">
							© 1999-{new Date().getFullYear()} Businessolver
						</a>
					</Col>
					<Col md={6} className="order-md-0">
						<ul className="nav justify-content-center justify-content-md-end">
							<li className="nav-item">
								<a href="#top" className="nav-link">
									Privacy
								</a>
							</li>

							<li className="nav-item">
								<a href="#top" className="nav-link">
									Browsers
								</a>
							</li>

							<li className="nav-item">
								<Dropdown>
									<Dropdown.Toggle className="footerDropdown" variant="default" id="dropdown-basic">
										English
									</Dropdown.Toggle>

									<Dropdown.Menu>
										<Dropdown.Item href="#top">English</Dropdown.Item>
										<Dropdown.Item href="#top">Espanol</Dropdown.Item>
										<Dropdown.Item href="#top">Francais</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							</li>
						</ul>
					</Col>
				</Row>
			</div>
		</footer>
	);
}
